import { render, staticRenderFns } from "./AgendaDayComponent.vue?vue&type=template&id=18d0c363&scoped=true"
import script from "./AgendaDayComponent.vue?vue&type=script&lang=js"
export * from "./AgendaDayComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaDayComponent.vue?vue&type=style&index=0&id=18d0c363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0c363",
  null
  
)

export default component.exports